import { Slide, Snackbar } from "@material-ui/core";
import { TransitionProps } from "@material-ui/core/transitions";
import { Alert } from "@material-ui/lab";
import React from "react";
import { useSelector } from "react-redux";
import useCleverlynkFunctions from "../../hooks/useCleverlynkFunctions";
import { selectSnackbar } from "../../redux/slices/cleverlynkSlice";

function SlideTransition(props: TransitionProps) {
  return <Slide {...props} direction="up" />;
}

const ClynkSnackbar = () => {
  const snackbar = useSelector(selectSnackbar);
  const { handleModifySnackbar } = useCleverlynkFunctions();

  return (
    <Snackbar
      style={{ bottom: snackbar?.anchor ? undefined : 75 }}
      TransitionComponent={snackbar?.anchor ? undefined : SlideTransition}
      open={snackbar !== null}
      transitionDuration={{ enter: 300, exit: 0 }}
      anchorOrigin={snackbar?.anchor ?? { vertical: "bottom", horizontal: "center" }}
      autoHideDuration={snackbar?.time !== undefined ? snackbar?.time : 6000}
      ClickAwayListenerProps={snackbar?.disableClickAway ? { mouseEvent: false, touchEvent: false } : undefined}
      onClose={() => handleModifySnackbar(null)}>
      <Alert
        severity={snackbar?.type}
        onClose={snackbar?.disableClickAway ? () => handleModifySnackbar(null) : undefined}>
        {snackbar?.message}
      </Alert>
    </Snackbar>
  );
};
export default ClynkSnackbar;
